import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {
  p: 1,
};

export const tabUpdateCount: SxStyleFunc<boolean> = (active) => ({
  backgroundColor: active ? 'primary.500' : 'grey.300',
  paddingX: 0.5,
  borderRadius: 0.75,
});
